module.exports = __webpack_public_path__ + "static/img/tk1.307cd84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/tk/tk1.jpg
// module id = EaZx
// module chunks = 7